import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Button,
  Flex,
  Grid,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Text,
  useBreakpointValue,
  VStack,
} from "@chakra-ui/react";
import { AppContext } from "AppProvider/AppContext";
import FileViewer from "components/common/FileViewerPdfAndImage/FileViewer";
import { useContext, useEffect, useRef, useState } from "react";
import { appRequest } from "routes";
import CommentDrawer from "../CommentDrawer/CommentDrawer";
import DynamicFormTable from "./component/DynamicTableLabel";
import { DrawerProps } from "./utils/constant";
import {
  checkTableTransformData,
  transformDataForInitial,
  TransformDataFormField
} from "./utils/function";
import { getFiUser } from "../function";
import DynamicFormJson from "./component/DynamicFormJson";
import MtDynamicTableLabel from "./component/MtDynamicTableLabel";

export default function MmtDynamicSchemaModal({
  file,
  isOpen,
  onClose,
  data,
  commentModel,
  setCommentModel,
  selectedRows,
  setSelectedRows,
  handleGet,
  name,
  openSchemaModal,
  statusType,
  activePage,
}: any): JSX.Element {
  const { toastNotify, workFlowData, accountDetails, workflowProcess } =
    useContext(AppContext);
  const [selectedFile, setSelectedFile] = useState<any>(null);
  const [initialDocumentLoading, setInitialDocumentLoading] = useState(false);
  const [uploadSelectedFile, setUploadSelectedFile] = useState<any>(null);
  const [fetchFileLoader, setFetchFileLoader] = useState<boolean>(false);
  const [isViewerOpen, setIsViewerOpen] = useState<boolean>(false);
  const [financialCompany, setFinancialCompany] = useState(0);
  const [financialForm, setFinancialForm] = useState({
    companyCode: null,
    plantCode: null,
    gstVendorCode: null,
    isTdsApplicable: false,
    tdsTaxCode: null,
    tdsBasicAmount: "",
    isExchangeRateApplicable: false,
    exchangeRate: "",
    invoiceType: null,
    postingDate: new Date().toISOString().split("T")[0],
    baseLineDate: new Date().toISOString().split("T")[0],
    bussinessPlace: "",
    referenceKey1: "",
    referenceKey2: "",
    referenceKey3: "",
    vendorText: "",
    taxJurisdiction: "",
    department: null,
    bukrs: null,
    remark: "",
    lineItems: [],
    tillomedApproval: undefined,
    vendorAddress: "",
    marcanUserFourFollowUp: true,
    glProfitCenter: undefined,
    glBusinessArea: undefined,
    glInternalOrder: undefined,
    glAccount: undefined,
    glPlantCode: undefined,
    glBusinessPlace: undefined,
    glLineItemsRemark: undefined,
    tdsSectionType: "tds",
    glAmount: undefined,
    roundOffAmount: 0,
    creditIndicator: "h",
  });

  const [lineItems, setLineItems] = useState<any>([]);
  const [dynamicSchemaData, setDynamicSchemaData] = useState<any>({
    fields: {},
    tables: [],
  });
  const [tableError, setTableError] = useState({});
  const [finalFieldValues, setFinalFieldValues] = useState<any>({});
  const [values, setValues] = useState<any>({}); // Changed from let to useState

  const formRef = useRef<any>();
  const tableRefs = useRef<any[]>([]);

  const viewerWidth = useBreakpointValue({ lg: true });
  let width = file ? "95vw" : "75vw";

  // Initialize values state based on openSchemaModal
  if (openSchemaModal?.initialUpload === true) {
    // No need to set values here since it's handled by useState
  } else {
  }

  const [sample, setSample] = useState({
    url: "",
    file: null,
    type: null,
    buffer: null,
  });

  const [initialValues, setInitialValues] = useState<any>({
    fields: null,
    tables: null,
    originalFields: null,
  });

  interface FieldValue {
    originalValue: any;
    editFieldValue: any;
  }

  interface Changes {
    index: number;
    result: FieldValue;
  }

  interface FieldData {
    [key: string]: {
      originalValue: any;
      editFieldValue: any;
      changes?: Changes[];
    };
  }

  useEffect(() => {
    if (openSchemaModal?.initialUpload === false) {
      setValuesFunction(data?.values);
      setValues(data?.values || {});
    }
  }, [data]);

  const mergeFields = (data: any): FieldData => {
    if (!Array.isArray(data)) {
      data = [data];
    }
    const result: any = {};

    const mergeValues = (fieldData: FieldData) => {
      Object.keys(fieldData).forEach((key) => {
        const field: any = fieldData[key];
        if (typeof field === "object" && !Array.isArray(field)) {
          if (field.hasOwnProperty("originalValue")) {
            // This is a field with original and edit values
            const latestValue = field;
            result[key] = latestValue;
          } else {
            // This is a nested object
            result[key] = mergeValues(field as FieldData);
          }
        }
      });
    };

    // Create a map to keep track of the latest index for each field
    const fieldMap: Map<string, FieldValue> = new Map();

    data.forEach((entry: any) => {
      const processFields = (fields: FieldData, prefix: string = "") => {
        Object.keys(fields || {}).forEach((field) => {
          const currentPath = prefix ? `${prefix}.${field}` : field;
          const fieldData: any = fields[field];

          if (typeof fieldData === "object" && !Array.isArray(fieldData)) {
            if (fieldData && fieldData?.hasOwnProperty("originalValue")) {
              // This is a field with original and edit values
              if (!fieldMap.has(currentPath)) {
                fieldMap.set(currentPath, {
                  originalValue: fieldData.originalValue,
                  editFieldValue: fieldData.editFieldValue,
                });
              } else {
                const currentValue: any = fieldMap.get(currentPath);
                if (
                  fieldData.editFieldValue !== null &&
                  fieldData.editFieldValue !== undefined
                ) {
                  fieldMap.set(currentPath, {
                    ...currentValue,
                    editFieldValue: fieldData.editFieldValue,
                  });
                }
              }
            } else {
              // This is a nested object, process recursively
              processFields(fieldData as FieldData, currentPath);
            }
          }
        });
      };

      processFields(entry?.values?.fields || {});
    });

    // Construct final merged values
    fieldMap.forEach((value, key) => {
      const keys = key.split(".");
      let temp: any = result;
      for (let i = 0; i < keys.length - 1; i++) {
        const k = keys[i];
        if (!temp[k]) temp[k] = {};
        temp = temp[k] as FieldData;
      }
      temp[keys[keys.length - 1]] = value;
    });

    return result;
  };

  const mergedData = mergeFields(values);

  useEffect(() => {
    // setFinalFieldValues(mergeEditedValues(values));
  }, [values]);

  const setValuesFunction = (data?: any) => {
    let initialFields: any = {};
    let initialTables: any = [];
    let originalInitialFieldsValues: any = {};
    let initialFinancialForm: any = {};

    // Use data if provided, otherwise use a default structure
    const currentValues =
      data !== undefined
        ? data
        : { values: { fields: {}, tables: [], financialForm: {} } };
    if (Array.isArray(currentValues)) {
      initialFields =
        currentValues.length > 0
          ? transformDataForInitial(
            currentValues[currentValues.length - 1]?.values?.fields,
          )
          : {};
      originalInitialFieldsValues =
        currentValues.length > 0
          ? currentValues[currentValues.length - 1]?.values?.fields
          : {};
      initialTables = checkTableTransformData(currentValues);

      setLineItems(initialTables[0]?.Invoice_line_Items || []);

      if (
        currentValues?.length > 0 &&
        currentValues[currentValues.length - 1]?.values?.financialForm
      ) {
        let dts =
          currentValues[currentValues.length - 1]?.values?.financialForm;
        if (dts) {
          if (dts?.lineItems?.length > 0) {
            setFinancialCompany(dts?.companyCode);
            let options = dts.lineItems.map((it: any) => ({
              ...it,
              businessAreaOptions: it.businessArea ? [it.businessArea] : [],
              costCenterOptions: it.costCenter ? [it.costCenter] : [],
              profitCenterOptions: it.profitCenter ? [it.profitCenter] : [],
              internalOrderOptions: it.internalOrder
                ? [it.internalOrderOptions]
                : [],
            }));
            setLineItems(options);
          }
          if (
            accountDetails?.level === "level-3" &&
            workflowProcess?.processName === "marcan" &&
            workflowProcess?.processType === "NonPo"
          ) {
            setFinancialForm({
              ...dts,
              referenceKey1: dts.referenceKey1
                ? dts.referenceKey1
                : accountDetails?.username,
              postingDate: new Date().toISOString().slice(0, 10),
            });
          } else {
            if (getFiUser(workFlowData?.processName, accountDetails?.level)) {
              setFinancialForm({
                ...dts,
                postingDate: new Date().toISOString().slice(0, 10),
              });
            } else {
              setFinancialForm({
                ...dts,
                postingDate: new Date().toISOString().slice(0, 10),
              });
              // setFinancialForm(dts)
            }
          }
        }
      }
    } else if (typeof currentValues === "object" && currentValues !== null) {
      initialFields = currentValues?.values?.fields || {};
      initialTables = currentValues?.values?.tables || [];
      originalInitialFieldsValues = currentValues?.values?.fields || {};
    } else {
      initialFields = {};
      initialTables = [];
    }

    // Update the values state only if data is provided
    if (data !== undefined) {
      setValues(data);
    }

    setInitialValues((prev: any) => ({
      ...prev,
      fields: initialFields,
      tables: initialTables,
      originalFields: originalInitialFieldsValues,
    }));
  };

  // useEffect(() => {
  //   setValuesFunction();
  // }, []);

  function isEmpty(obj: any): boolean {
    if (obj === null || typeof obj !== "object") {
      return false;
    }
    if (Object.keys(obj).length === 0) {
      return true;
    }
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (isEmpty(obj[key])) {
          continue;
        } else {
          return false;
        }
      }
    }
    return true;
  }

  useEffect(() => {
    if (openSchemaModal?.initialUpload === false && file) {
      setSelectedFile(file?._id);
      setIsViewerOpen(true);
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen && openSchemaModal?.initialUpload === false) {
      if (file) {
        getFile();
      }
    }
  }, [isOpen, selectedFile]);

  const getFile = async () => {
    try {
      if (selectedFile) {
        setFetchFileLoader(true);
        const response: any = await appRequest("filesystem", "get", {
          id: selectedFile,
        });
        if (response) {
          if (response?.error) {
          } else {
            let buffer =
              typeof response === "string" ? JSON.parse(response) : response;
            buffer = new Uint8Array(buffer);

            const fileURL = URL.createObjectURL(
              new Blob([buffer], { type: file.metadata.contentType }),
            );
            setSample({
              url: fileURL,
              file: file,
              type: file.metadata.contentType,
              buffer: buffer,
            });
          }
        }
      }
    } catch (error: any) {
      toastNotify({
        title: "Error",
        message: error.message,
        type: "error",
      });
    } finally {
      setFetchFileLoader(false);
    }
  };

  const extractData = async (sendFile: any) => {
    try {
      setInitialDocumentLoading(true);
      const response: any = await appRequest(
        "document",
        "extractData",
        sendFile,
      );
      if (response?.status === "success") {
        setValuesFunction([{ ...response.data?.data }]);
      }
      // console.log('the response are', response?.data)
      // data = fakeResponse;
      // setValuesFunction(fakeResponse);
      // console.log("the response are", response);
    } catch (err: any) {
      console.log(err?.message);
    } finally {
      setInitialDocumentLoading(false);
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      let dt = URL.createObjectURL(file);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        const base64String = reader.result as string;
        setUploadSelectedFile({
          name: file.name,
          file: base64String,
          url: dt,
          type: file.type,
        });
        extractData({
          file: {
            fileName: file.name,
            file: base64String,
            type: file.type,
          },
          type: "tillomed",
        });
      };
      reader.onerror = (error) => {
        console.error("Error reading file:", error);
      };
    } else {
      alert("Please upload a file");
    }
  };

  const changeTabFunction = () => {
    console.log("form response are", formRef);
    if (tableRefs && tableRefs?.current) {
      tableRefs.current.forEach((tableRef) => {
        if (tableRef && tableRef.handleSave) {
          tableRef.handleSave();
        }
      });
    }

    setDynamicSchemaData((prevState: any) => ({
      ...prevState,
      fields: TransformDataFormField(
        formRef?.current?.values || {},
        initialValues.fields,
      ),
    }));
  };


  function base64ToBlob(base64: string, contentType = "", sliceSize = 512) {
  const byteCharacters = atob(base64);
  const byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Uint8Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    byteArrays.push(byteNumbers);
  }
  return new Blob(byteArrays, { type: contentType });
}

  const getFilesData = async (fileId: any) => {
        try {
          if (fileId && data) {
            setFetchFileLoader(true);
            const response: any = await appRequest("document", "previewDocument", { fileId });
            if (response && response.base64) {
              const contentType = response.contentType || file.metadata?.contentType || "application/pdf";
              const blob = base64ToBlob(response.base64, contentType);
              const fileURL = URL.createObjectURL(blob);
              setSample({ url: fileURL, file: file, type: contentType,  buffer: response.base64 });
            }
          }
        } catch (error: any) {
          toastNotify({ title: "Error", message: error.message, type: "error" });
        } finally {
          setFetchFileLoader(false);
        }
      };


  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full" isCentered>
      <ModalOverlay />
      <ModalContent
        position="fixed"
        right={isOpen ? "0" : `-${width}`}
        top="0"
        height="100vh"
        width={viewerWidth ? width : "100vw"}
        animation={`${isOpen ? "slideIn" : "slideOut"
          } 0.8s ease-in-out forwards`}
      >
        <ModalHeader
          fontSize={{ base: "md", lg: "xl" }}
          color="teal.300"
          fontWeight="700"
          p=".6rem .6rem"
          ml="1rem"
        >
          Document
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody
          px={{ base: ".5rem", lg: "1.5rem" }}
          py=".2rem"
          mb={{ base: "1rem", lg: "unset" }}
          overflowX="auto"
          className="customScrollBar"
        >
          <Grid
            templateColumns={{ lg: file ? "1fr 1.5fr" : "1fr" }}
            columnGap={{ lg: 5 }}
            rowGap={2}
          >
            {openSchemaModal?.initialUpload === true ? (
              <Flex direction="column">
                <Input
                  name="document"
                  type="file"
                  className="chooseFile"
                  // ref={fileInputRef}
                  accept={[".pdf", ".png", ".jpg"].join(",")}
                  onChange={(e: any) => handleFileChange(e)}
                  mb={2}
                />
                {uploadSelectedFile && (
                  <FileViewer sample={uploadSelectedFile} />
                )}
              </Flex>
            ) : (
              file &&
              (fetchFileLoader ? (
                <Box
                  h={{
                    base: "70vh",
                    md: "60vh",
                    lg:
                      accountDetails?.role !== "admin" &&
                        name === "Pending Approval"
                        ? "82vH"
                        : "85vH",
                  }}
                  mb="1rem"
                  w="100%"
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Spinner
                    size="xl"
                    thickness="4px"
                    speed="0.65s"
                    color="teal.400"
                  />
                </Box>
              ) : (
                <Box
                  h={{
                    base: "70vh",
                    md: "60vh",
                    lg:
                      accountDetails?.role !== "admin" &&
                        name === "Pending Approval"
                        ? "82vH"
                        : "85vH",
                  }}
                  position="relative"
                  overflow="hidden"
                  w="100%"
                >
                  <FileViewer activePage={activePage} sample={sample} docId={data?.documentId} recallApi={(fileId: any) => { handleGet(); getFilesData(fileId) }} />
                </Box>
              ))
            )}
            <Box
              // border="2px solid"
              // borderColor="teal.400"
              // borderRadius={8}
              maxH={{
                base: "70vh",
                lg:
                  accountDetails?.role !== "admin" &&
                    name === "Pending Approval"
                    ? "82vH"
                    : "85vH",
              }}
              overflowY="auto"
              className="customScrollBar"
              pr={2}
            >
              {initialDocumentLoading === true ? (
                <Flex minH="80vh" justify="center" align="center">
                  <VStack spacing={4}>
                    <Spinner
                      thickness="6px"
                      speed="0.65s"
                      emptyColor="gray.200"
                      color="blue.500"
                      size="xl"
                    />
                    <Text fontSize="lg" fontWeight="medium" color="gray.600">
                      Loading, please wait...
                    </Text>
                  </VStack>
                </Flex>
              ) : (
                <Accordion
                  allowMultiple
                  defaultIndex={[
                    0,
                    ...(workFlowData?.schema?.tables?.length > 0
                      ? Object.keys(workFlowData.schema.tables[0]).map(
                        (_, i) => i + 1,
                      )
                      : []),
                  ]}
                  onChange={() => changeTabFunction()}
                >
                  {/* ---------------- Fields Section ---------------- */}
                  <AccordionItem border="none" mb={4}>
                    <h2>
                      <AccordionButton
                        bg="teal.50"
                        _hover={{ bg: "teal.100" }}
                        borderRadius="md"
                        p={3}
                      >
                        <Box
                          flex="1"
                          textAlign="left"
                          fontWeight="700"
                          color="teal.700"
                        >
                          Fields
                        </Box>
                        <AccordionIcon color="teal.500" />
                      </AccordionButton>
                    </h2>
                    <AccordionPanel pb={4} px={0}>
                      {initialValues.fields &&
                        initialValues.originalFields &&
                        mergedData && (
                          <Box
                            mt={2}
                            h="auto"
                            overflowY="visible"
                            px={4}
                            borderLeft="2px solid"
                            borderColor="teal.100"
                            ml={2}
                          >
                            <DynamicFormJson
                              formRef={formRef}
                              schema={{
                                fields: workFlowData?.schema?.fields || {},
                              }}
                              initialValuess={initialValues.fields}
                              originalFields={mergedData || {}}
                              isDisabled={
                                workFlowData?.fieldsToDisable
                                  ? workFlowData.fieldsToDisable.includes(
                                    accountDetails?.level,
                                  )
                                    ? false
                                    : true
                                  : true
                              }
                              finalFieldValues={finalFieldValues}
                              onSubmit={({ values, setSubmitting }: any) => {
                                setSubmitting(false);
                                setDynamicSchemaData((prevState: any) => ({
                                  ...prevState,
                                  fields: TransformDataFormField(
                                    values,
                                    initialValues.fields,
                                  ),
                                }));
                              }}
                            />
                          </Box>
                        )}
                    </AccordionPanel>
                  </AccordionItem>

                  {/* ---------------- Dynamic Table Sections ---------------- */}
                  {workFlowData?.schema?.tables?.length > 0 &&
                    initialValues.tables &&
                    Object.keys(workFlowData.schema.tables[0]).map(
                      (tableName: string, index: number) => {
                        const tableSchema =
                          workFlowData.schema.tables[0][tableName];

                        const tableDataEntry = initialValues.tables.find(
                          (entry: any) => Object.keys(entry)[0] === tableName,
                        );

                        const tableData = tableDataEntry
                          ? tableDataEntry[tableName]
                          : [];

                        let updatedValues: any = [];

                        if (Array.isArray(values)) {
                          updatedValues = values.map((item) => ({
                            ...item,
                            values: {
                              ...item.values,
                              tables: item.values?.tables?.[tableName] || [],
                            },
                          }));
                        }

                        return (
                          <AccordionItem key={tableName} border="none" mb={4}>
                            <h2>
                              <AccordionButton
                                bg="teal.50"
                                _hover={{ bg: "teal.100" }}
                                borderRadius="md"
                                p={3}
                              >
                                <Box
                                  flex="1"
                                  textAlign="left"
                                  fontWeight="700"
                                  color="teal.700"
                                >
                                  {tableName.split("_").join(" ")}
                                </Box>
                                <AccordionIcon color="teal.500" />
                              </AccordionButton>
                            </h2>
                            <AccordionPanel pb={4} px={0}>
                              <Box
                                borderLeft="2px solid"
                                borderColor="teal.100"
                                ml={2}
                                px={2}
                              >
                                <MtDynamicTableLabel
                                  schema={tableSchema || {}}
                                  tableData={tableData || []}
                                  lineItems={lineItems}
                                  setLineItems={setLineItems}
                                  isMmt={true}
                                  submittedData={
                                    Array.isArray(values)
                                      ? updatedValues
                                      : values
                                  }
                                  file={file}
                                  tableName={tableName}
                                  onSubmit={(tableValues: any) => {
                                    setDynamicSchemaData((prevState: any) => ({
                                      ...prevState,
                                      tables: {
                                        ...prevState.tables,
                                        [tableName]: tableValues,
                                      },
                                    }));
                                  }}
                                  ref={(el: any) =>
                                    (tableRefs.current[index] = el)
                                  }
                                  errors={tableError}
                                  setErrors={setTableError}
                                  name={name}
                                  isDisabled={
                                    workFlowData?.fieldsToDisable
                                      ? workFlowData.fieldsToDisable.includes(
                                        accountDetails?.level,
                                      )
                                        ? false
                                        : true
                                      : true
                                  }
                                />
                              </Box>
                            </AccordionPanel>
                          </AccordionItem>
                        );
                      },
                    )}
                </Accordion>
              )}
            </Box>
          </Grid>
        </ModalBody>
        <ModalFooter>
          {name === "Pending Approval" &&
            // accountDetails.level !== "level-1" &&
            accountDetails.role !== "admin" && (
              <>
                <Button
                  display={
                    accountDetails?.level === "admin" ? "none" : undefined
                  }
                  onClick={() => {
                    let allTablesValid = true;
                    if (tableRefs && tableRefs?.current) {
                      tableRefs.current.forEach((tableRef) => {
                        if (tableRef && tableRef.handleSave) {
                          const isValid = tableRef.handleSave();
                          if (!isValid) allTablesValid = false;
                        }
                      });
                    }
                    if (formRef.current) {
                      formRef.current.submitForm();
                      formRef.current.validateForm().then((errors: any) => {
                        if (errors && Object.keys(errors).length > 0) {
                          const message = Object.entries(errors)
                            .map(
                              ([key, value]) =>
                                `${key.replace(/_/g, " ")}: ${value}`,
                            )
                            .join("\n");

                          toastNotify({
                            title: "Validation Error",
                            message,
                            type: "info",
                          });

                          return;
                        }
                        if (
                          Object.keys(errors).length === 0 &&
                          isEmpty(tableError) &&
                          allTablesValid
                        ) {

                          const category = (formRef?.current?.values?.Invoice_Category || "").toLowerCase().trim();
                          const subCategory = (formRef?.current?.values?.Invoice_Sub_Category_For_Flight || "")
                            .toLowerCase()
                            .trim();

                          if (category === "flight") {
                            if (!["international", "domestic"].includes(subCategory)) {
                              alert("For Flight invoices, sub-category must be Domestic or International.");
                              return;
                            }
                          }

                          // ✅ Open comment modal if no validation errors
                          setCommentModel({
                            open: true,
                            selectedStatus: "approved",
                            comment: "",
                            isMulti: false,
                          });

                          // Submit form after modal setup
                          formRef.current.submitForm();
                        }
                      });
                    }
                  }}
                  fontSize="sm"
                  bg="green.500"
                  color="white"
                  _hover={{ bg: "green.600" }}
                  mr="1rem"
                  w="100px"
                >
                  Accept
                </Button>
                <Button
                  display={
                    accountDetails?.level === "admin" ? "none" : undefined
                  }
                  onClick={() => {
                    let allTablesValid = true;
                    if (tableRefs && tableRefs?.current) {
                      tableRefs.current.forEach((tableRef) => {
                        if (tableRef && tableRef.handleSave) {
                          const isValid = tableRef.handleSave();
                          if (!isValid) allTablesValid = false;
                        }
                      });
                    }
                    if (formRef.current) {
                      formRef.current.submitForm();
                      formRef.current.validateForm().then((errors: any) => {
                        if (
                          Object.keys(errors).length === 0 &&
                          isEmpty(tableError) &&
                          allTablesValid
                        ) {
                          setCommentModel({
                            open: true,
                            selectedStatus: "rejected",
                            comment: "",
                            isMulti: false,
                          });
                          formRef.current.submitForm();
                        }
                      });
                    }
                  }}
                  bg="red.500"
                  _hover={{ bg: "red.600" }}
                  color="white"
                  w="100px"
                  mr="14px"
                >
                  Reject
                </Button>
              </>
            )}
        </ModalFooter>
      </ModalContent>
      <style>
        {`
          @keyframes slideIn {
            from {
              right: -${width};
            }
            to {
              right: 0;
            }
          }
          @keyframes slideOut {
            from {
              right: 0;
            }
            to {
              right: -${width};
            }
          }
        `}
      </style>
      <CommentDrawer
        commentModel={commentModel}
        setCommentModel={setCommentModel}
        isOpen={commentModel.open}
        width={width}
        onClose={onClose}
        view={true}
        additionalFields={{ file: uploadSelectedFile, type: "schema" }}
        createNew={openSchemaModal?.initialUpload === true ? true : false}
        handleClose={onClose}
        statusType={statusType}
        editedValues={{
          ...dynamicSchemaData,
          financialForm: {
            ...financialForm,
            lineItems: financialForm?.lineItems
              ? financialForm?.lineItems?.map(
                ({
                  businessAreaOptions,
                  glAccountOptions,
                  costCenterOptions,
                  internalOrderOptions,
                  profitCenterOptions,
                  ...rest
                }: any) => rest,
              ) || []
              : [],
          },
        }}
        // editedValues={{ ...dynamicSchemaData, financialForm: financialForm }}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        handleGet={handleGet}
        isSchema={true}
      />
    </Modal>
  );
}